module.exports = __webpack_public_path__ + "media/images/partner/gesundheitsdepartement_bs-2466e39a32eed8e89f8202f89488292f.png";